// extracted by mini-css-extract-plugin
module.exports = {"blueButton":"MultipurposeButton_blueButton__3qgPC","buttonBlock":"MultipurposeButton_buttonBlock__1QfJt","spin":"MultipurposeButton_spin__25v5U"};